<!--
 Always in the DOM, hidden until it has something to draw: the tracks are attached to this very
 element, and an element behind an `@if` would not exist at the moment the room hands them over.
 `muted` is off on purpose — a live theatre without its sound is half a stream; the browser's own
 autoplay block is lifted by the button below instead.
-->
<video
  #liveVideo
  class="h-full w-full object-contain"
  [class.hidden]="!playing()"
  autoplay
  playsinline></video>

@if (!playing()) {
  <div
    class="flex h-full w-full flex-col items-center justify-center gap-4 bg-gray-600 py-20 md:gap-6">
    <div>
      <svg mai-waiting-video class="text-white"></svg>
    </div>
    <div class="px-4 text-center text-white">
      <p>{{ waitingText() }}</p>
    </div>

    @if (pending()) {
      <mib-dots-loader size="sm" color="light" label="Connecting to the live"></mib-dots-loader>
    } @else if (status() === 'error') {
      <button
        type="button"
        class="focus-visible:outline-mib-primary rounded-mib border border-white/40 px-4 py-2 text-white hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2"
        (click)="retry()">
        Try again
      </button>
    }
  </div>
}

<!--
 Over the picture rather than beside it: the stream is already playing, silently, and the viewer
 has to be able to fix that without losing sight of it. Only a real gesture lifts the block, so
 this cannot be done for them.
-->
@if (audioBlocked()) {
  <button
    type="button"
    class="focus-visible:outline-mib-primary absolute top-3 right-3 rounded-mib bg-black/70 px-3 py-2 text-sm text-white hover:bg-black/85 focus-visible:outline-2 focus-visible:outline-offset-2"
    (click)="enableAudio()">
    Enable sound
  </button>
}
